module.exports = "/_next/static/images/mugitoolive_michelin-a1e15fc108d6b86569a741c577c81583.jpg";